// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".noAuthAdmin_root__2MkEZ {\n  width: 1440px;\n  height: 920px;\n  min-height: 100vh;\n  background: #343b4c;\n  opacity: 0.9;\n  display: flex; }\n", ""]);
// Exports
exports.locals = {
	"root": "noAuthAdmin_root__2MkEZ"
};
module.exports = exports;
